import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../App';
import { BarChart3, Package, ShoppingCart, ClipboardList, ArrowLeftRight, TrendingUp, Truck, Building2, Users, Settings, Clipboard, CheckSquare } from 'lucide-react';
import { isOperationsUser, isCommandCenterUser } from '../../utils/dashboardResolver';

const navItems = [
  { path: '/operations', label: 'Operations', icon: Clipboard, showIf: 'operations' },
  { path: '/', label: 'Command Center', icon: BarChart3, showIf: 'command-center' },
  { path: '/inventory', label: 'Inventory', icon: Package },
  { path: '/products', label: 'Products', icon: ShoppingCart },
  { path: '/orders', label: 'Purchase Orders', icon: ClipboardList },
  { path: '/transfers', label: 'Transfers', icon: ArrowLeftRight },
  { path: '/tasks', label: 'Tasks', icon: CheckSquare },
  { path: '/reports', label: 'Reports', icon: TrendingUp, roles: ['admin', 'manager'] },
  { path: '/suppliers', label: 'Suppliers', icon: Truck },
  { path: '/locations', label: 'Locations', icon: Building2, roles: ['admin', 'manager'] },
  { path: '/users', label: 'Users', icon: Users, roles: ['admin'] },
  { path: '/settings', label: 'Settings', icon: Settings },
];

export default function Sidebar() {
  const { user, logout } = useAuth();

  return (
    <div className="sidebar">
      <div className="logo">
        <h1><span className="logo-stock">Stock</span><span className="logo-pour">Pour</span></h1>
      </div>
      <nav style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {navItems.filter(item => {
          if (item.roles && !item.roles.includes(user?.role)) return false;
          if (item.showIf === 'operations') return isOperationsUser(user);
          if (item.showIf === 'command-center') return isCommandCenterUser(user);
          return true;
        }).map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/' || item.path === '/operations'}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '10px 20px',
              color: isActive ? 'var(--gold)' : 'var(--muted)',
              borderLeft: isActive ? '3px solid var(--gold)' : '3px solid transparent',
              background: isActive ? 'var(--gold-pale)' : 'transparent',
              fontSize: 14,
              fontWeight: isActive ? 600 : 400,
              transition: 'all 0.2s'
            })}
          >
            <item.icon size={18} />
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div style={{ position: 'absolute', bottom: 20, left: 0, right: 0, padding: '0 20px' }}>
        <div style={{ padding: '12px', background: 'var(--card)', borderRadius: 8, marginBottom: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 600 }}>{user?.name}</div>
          <div style={{ fontSize: 11, color: 'var(--muted)', textTransform: 'capitalize' }}>{user?.role}</div>
        </div>
        <button onClick={logout} className="btn btn-secondary" style={{ width: '100%', justifyContent: 'center', fontSize: 13 }}>
          Sign Out
        </button>
      </div>
    </div>
  );
}
